import { alias, list, object, primitive, serializable } from 'serializr';
import { CoProducts } from './coProducts.model';
import { RcFile } from 'antd/lib/upload';

export class Commodity {
  @serializable
  id?: number;

  @serializable
  name?: string;

  @serializable
  image?: RcFile;

  @serializable(alias('location_id', primitive()))
  locationId?: string;

  @serializable(alias('farm_name', primitive()))
  farmName?: string;

  @serializable(alias('harvest_year', primitive()))
  harvestYear?: number;

  @serializable(alias('crop_id', primitive()))
  cropId?: number;

  @serializable
  area?: number;

  @serializable(alias('area_unit', primitive()))
  areaUnit?: string;

  @serializable(alias('wet_weight', primitive()))
  wetWeight?: number;

  @serializable(alias('dry_weight', primitive()))
  dryWeight?: number;

  @serializable(alias('revenue_percentage', primitive()))
  revenuePercentage?: number;

  @serializable
  description?: string;

  @serializable(alias('image_url', primitive()))
  imageUrl?: string;

  @serializable(alias('co_products', list(object(CoProducts))))
  coProducts?: CoProducts[];

  @serializable
  status?: string;

  @serializable
  stage?: number;

  @serializable
  type?: string;
}

export class Stage0MetaData {
  @serializable(alias('id', primitive()))
  value?: number;

  @serializable(alias('name', primitive()))
  label?: number;

  @serializable
  type?: string;
}
